import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './CoverSection.css';


class CoverSection extends Component {
  render() {
    return (
      <Grid>
        <Row className={s.coveredsection}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={cx(s.seperator, s.boxseperator)}></div>
            <div className={cx(s.mainhedding, 'mainheddingRTLMobile')}>
              <h1>coverSectionTitle1</h1>
            </div>
            <Col xs={12} sm={12} md={6} lg={6} className={s.coveredtextarea}>
              <p className={s.common}>coverSectionContent1</p>
              <p className={s.common}>coverSectionContent2</p>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <ul className={cx(s.coverul, 'coverulAr')}>
                <li>coverSectionFeature1</li>
                <li>coverSectionFeature2</li>
                <li>coverSectionFeature3</li>
                <li>coverSectionFeature4</li>
                <li>coverSectionFeature5</li>
                <li>coverSectionFeature6</li>
              </ul>
            </Col>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default withStyles(s)(CoverSection);



// WEBPACK FOOTER //
// src/components/FindOutMore/CoverSection/CoverSection.js